import React, {CSSProperties} from 'react'
import {Box, Grid, ListItem, ListItemButton} from "@mui/material";
import {DISABLED_COLOR, HILIGHT_COLOR} from "../../constants/constants";
import AppointmentStatus from "../../models/AppointmentStatus";
import {getShortenDateWithYear} from "../../utils/Utils";
import {UserAppointment} from "../../models/UserAppointment";
import {useNavigate} from "react-router-dom";

interface AppointmentListItemSpec {
    appointment: UserAppointment
}

export const AppointmentListItem: React.FC<AppointmentListItemSpec> = ({ appointment }) => {

    const navigate = useNavigate();
    const handleClick = (path: string) => {
        navigate(path);
    }

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={() => {handleClick(`/appointments/${appointment.id}`)}}>
                <Grid container>
                    <Grid container>
                        <Grid item>
                            <span style={getAppointmentItemStatusStyle(appointment.status)}>
                                {AppointmentStatus.toStatusString(appointment.status)}
                            </span>
                        </Grid>
                        <Grid item>
                            <Box width={"10px"} />
                        </Grid>
                        <Grid item>
                            <span style={getAppointmentItemTitleStyle(appointment.status)}>{appointment.name}</span>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item>
                            <span className={"description-text"}>{getShortenDateWithYear(appointment?.getPollDateFirstDate())} ~ {getShortenDateWithYear(appointment?.getPollDateLastDate())}</span>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemButton>
        </ListItem>
    )

    function getAppointmentItemStatusStyle(status: AppointmentStatus): CSSProperties {
        if (status === AppointmentStatus.SCHEDULING) {
            return {color: HILIGHT_COLOR, fontWeight: 700}
        }
        return {color: DISABLED_COLOR, fontWeight: 700}
    }

    function getAppointmentItemTitleStyle(status: AppointmentStatus): CSSProperties {
        if (status === AppointmentStatus.SCHEDULING) {
            return {fontWeight: 700}
        }
        return {color: DISABLED_COLOR, fontWeight: 700}
    }
}